import { Box, styled } from "@mui/material";
import { createShouldForwardPropBlockList } from "@pmag/ui-components";
import { type Props, ReactSVG } from "react-svg";

export interface SvgStyledProps extends Props {
    brandColor?: string | null;
}

const SvgStyledPrivate = styled(ReactSVG, {
    shouldForwardProp: createShouldForwardPropBlockList(["brandColor"]),
})<SvgStyledProps>(({ theme, brandColor }) => ({
    margin: theme.spacing(4, 0),

    svg: {
        width: "100%",
    },

    "& .highlighted": {
        fill: brandColor || theme.palette.core.black,
    },
}));

export const SvgStyled: React.FunctionComponent<SvgStyledProps> = (props) => {
    return <SvgStyledPrivate {...props} />;
};

export const ErrorFallback = styled(Box)(() => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: 100,
}));
